import type { RouteObject } from "react-router-dom";
import { lazy, Suspense, type ReactNode } from "react";
import { SkeletonGrid } from "../components/ui/Skeleton";

// Lazy load components
const Home = lazy(() => import("../pages/home/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const BookingPage = lazy(() => import("../pages/booking/page"));
const BookingSuccess = lazy(() => import("../pages/booking/success"));
const BookingCancel = lazy(() => import("../pages/booking/cancel"));
const MyBookings = lazy(() => import("../pages/MyBookings"));
const TicketDetail = lazy(() => import("../pages/TicketDetail"));
const MyAccount = lazy(() => import("../pages/MyAccount"));
const Settings = lazy(() => import("../pages/Settings"));
const Privacy = lazy(() => import("../pages/Privacy"));
const RefundPolicy = lazy(() => import("../pages/RefundPolicy"));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen bg-gray-50 p-4">
    <div className="max-w-7xl mx-auto">
      <div className="animate-pulse mb-8">
        <div className="h-8 bg-gray-300 rounded w-48 mb-4"></div>
        <div className="h-4 bg-gray-300 rounded w-96"></div>
      </div>
      <SkeletonGrid count={6} type="card" />
    </div>
  </div>
);

// Wrapper component with Suspense
const LazyWrapper = ({ children }: { children: ReactNode }) => (
  <Suspense fallback={<PageLoader />}>
    {children}
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <LazyWrapper>
        <Home />
      </LazyWrapper>
    ),
  },
  {
    path: "/booking",
    element: (
      <LazyWrapper>
        <BookingPage />
      </LazyWrapper>
    ),
  },
  {
    path: "/booking/success",
    element: (
      <LazyWrapper>
        <BookingSuccess />
      </LazyWrapper>
    ),
  },
  {
    path: "/booking/cancel",
    element: (
      <LazyWrapper>
        <BookingCancel />
      </LazyWrapper>
    ),
  },
  {
    path: "/my-bookings",
    element: (
      <LazyWrapper>
        <MyBookings />
      </LazyWrapper>
    ),
  },
  {
    path: "/ticket/:orderId",
    element: (
      <LazyWrapper>
        <TicketDetail />
      </LazyWrapper>
    ),
  },
  {
    path: "/my-account",
    element: (
      <LazyWrapper>
        <MyAccount />
      </LazyWrapper>
    ),
  },
  {
    path: "/settings",
    element: (
      <LazyWrapper>
        <Settings />
      </LazyWrapper>
    ),
  },
  {
    path: "/privacy",
    element: (
      <LazyWrapper>
        <Privacy />
      </LazyWrapper>
    ),
  },
  {
    path: "/refund-policy",
    element: (
      <LazyWrapper>
        <RefundPolicy />
      </LazyWrapper>
    ),
  },
  {
    path: "*",
    element: (
      <LazyWrapper>
        <NotFound />
      </LazyWrapper>
    ),
  },
];

export default routes;
